module.exports = __webpack_public_path__ + "img/home_banner01.7d370d67.webp";